import { Modal } from '@/components';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styles from '../styles.module.css';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { IframeMessageType } from '@/utils/iframePostMessages';

type CreateCompanyModalProps = {
  onCompanyCreated?: () => void;
};

function CreateCompanyModal({ onCompanyCreated }: CreateCompanyModalProps) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const closeModal = () => navigate(pathname);
  const [searchParams] = useSearchParams();
  const isOpen = searchParams.get('mode') === 'create';

  useEffect(() => {
    if (!isOpen) return;

    const handleMessage = (event: MessageEvent) => {
      const message = event.data;

      switch (message) {
        case IframeMessageType.REGISTRATION_COMPLETED:
          onCompanyCreated?.();
          toast.success('Company created successfully');
          closeModal();
          break;

        case IframeMessageType.ONBOARDING_COMPLETED:
          onCompanyCreated?.();
          toast.success('Onboarding completed successfully');
          closeModal();
          break;

        case IframeMessageType.CLOSE_IFRAME_WINDOW:
          closeModal();
          break;

        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [isOpen, onCompanyCreated]);

  const hubBaseUrl = (import.meta.env.VITE_HUB_URL || '').replace(/\/?$/, '/');
  const iframeSrc = `${hubBaseUrl}select-company/create`;

  return (
    <Modal open={isOpen} closeModal={closeModal} fitContent>
      <div className={styles.createCompanyModal}>
        <iframe src={iframeSrc} style={{ border: 'none' }} />
      </div>
    </Modal>
  );
}

export default CreateCompanyModal;
